export enum Mensagens {
    ConnectionErrorSummary = 'Erro de comunicação.',
    ConnectionErrorDetail = 'Não foi possível contactar o servidor. Tente novamente em instantes.',

    NotFoundErrorDetail = 'Informação passada está inválida ou não existe.',

    NotItensFound = 'Essa vigência não tem colaboradores.',

    ConnectionLoginSummary = 'Erro ao acessar',
    ConnectionLoginDetail = 'Usuário ou senha inválido.',

    UnauthorizedSummary = 'Não autorizado.',
    UnauthorizedDetail = 'Você não tem autorização para realizar essa operação. Contate o administrador do sistema.',

    CadastroSummary = 'Cadastro realizado.',
    CadastroDetail = 'O cadastro foi realizado com sucesso.',
    CadastroErroSummary = 'Erro ao cadastrar.',
    CadastroErroDetail = 'O cadastro não foi realizado, verifique suas informações.',

    UsuarioErrorDetail = 'O usuário já existe.',
    UsuarioExcluirErroDetail = 'O usuário possui vínculo ativo.',

    AtualizarSummary = 'Atualização realizada.',
    AtualizarDetail = 'A atualização foi realizada com sucesso.',
    AtualizarErroSummary = 'Erro ao atualizar.',
    AtualizarErroDetail = 'A atualização não foi realizada, verifique suas informações.',

    ExcluirSummary = 'Exclusão realizada.',
    ExcluirDetail = 'A exclusão foi realizada com sucesso.',
    ExcluirErroSummary = 'Erro ao excluir.',
    ExcluirErroDetail = 'A exclusão não foi realizada, verifique suas informações.',

    BuscarSummary = 'Busca realizada.',
    BuscarDetail = 'O colaborador foi encontrado.',
    BuscarErroSummary = 'Atenção.',
    BuscarErroDetail = 'O CPF inserido está incorreto ou não foi encontrado.',

    BuscarAlertaNaoOptanteSummary = 'Atenção.',
    BuscarAlertaNaoOptanteDetail = 'O usuário não é optante pelo vale transporte.',

    VincularSummary = "Vínculo realizado.",
    VincularDetail = "O colaborador foi vinculado ao seu usuário.",
    VincularErroSummary = "Vínculo não realizado.",
    VincularErroDetail = "O colaborador não foi vinculado ao seu usuário.",

    UpdateListSummary = " Atualização realizada",
    UpdateListDetail = "Sua solicitação foi concluída.",
    UpdateListErrorSummary = " Atualização não realizada",
    UpdateListErrorDetail = "Sua solicitação não foi concluída."
}
